export const WORD_NOT_VISIBLE_DETAIL_PAGE = [
    "Русский",
    "На узбекском",
    "Узбекский",
    "Зарубежные",
    "Фильм",
    "Сериалы",
    "Для взрослых",
    "Переведено на узбекский",
    "Для детей",
    "Премьера",
    "Новые серии",
    "Эксклюзив"
];
